var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQamLogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83594 1.98438L11.7188 4.86719C11.8828 5.03125 12 5.26562 12 5.5C12 5.75781 11.8828 5.99219 11.7188 6.15625L8.83594 9.03906C8.69531 9.17969 8.48438 9.25 8.27344 9.25C7.85156 9.25 7.5 8.89844 7.5 8.47656V7H4.5C4.07812 7 3.75 6.67188 3.75 6.25V4.75C3.75 4.35156 4.07812 4 4.5 4H7.5V2.54688C7.5 2.125 7.85156 1.75 8.27344 1.75C8.48438 1.75 8.69531 1.84375 8.83594 1.98438ZM3.75 1.75H2.25C1.82812 1.75 1.5 2.10156 1.5 2.5V8.5C1.5 8.92188 1.82812 9.25 2.25 9.25H3.75C4.14844 9.25 4.5 9.60156 4.5 10C4.5 10.4219 4.14844 10.75 3.75 10.75H2.25C1.00781 10.75 0 9.74219 0 8.5V2.5C0 1.25781 1.00781 0.25 2.25 0.25H3.75C4.14844 0.25 4.5 0.601562 4.5 1C4.5 1.42188 4.14844 1.75 3.75 1.75Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQamLogOut);
export default ForwardRef;